import { useQuery } from '@tanstack/react-query';

import { DASHBOARDS_KEY } from './constants';
import { getDashboardToken } from './dashboards';

export const useGetDashboardToken = (id: number) => {
  return useQuery({
    queryKey: [DASHBOARDS_KEY, id, 'Token'],
    queryFn: () => getDashboardToken(id),
    enabled: !!id,
  });
};
